module.exports = __webpack_public_path__ + "img/t_icon_1.3e0d2bcd.svg";